import Modal from "src/components/Common/UI/Modal/Modal";
import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { useDataLineBillingReport } from "./hooks/useDataLineBillingReport";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { Button } from "reactstrap";
import { MisterIcon } from "@rtel/mister-icons";
import CreateDataLineBilling from "./CreateDataLineBilling";
import DeleteBilling from "./DeleteBilling";
import EditDataLineBilling from "./EditDataLineBilling";


const DataLineBillingReport = ({handleCloseModal, dataLineID}: DataLineBillingReportProps) => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
  } = useDataLineBillingReport({dataLineID: dataLineID});

console.log("selectedRowsOfTable",selectedRowsOfTable)
  
  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={selectedRowsOfTable.length > 0} />
  );

  return (
    <Modal
      isOpen={true}
      closeFilterModal={handleCloseModal}
      title={"Ημερομηνίες Ελέγχου"}  
      size="full"
    >
       <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέος Έλεγχος`)}
      </Button>
      
      <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="xl"
          >
        {modalEvent.action === "create" && <CreateDataLineBilling handleCloseModal={closeActionModal} dataLineID={dataLineID}/> }
        {modalEvent.action === "edit" && <EditDataLineBilling handleCloseModal={closeActionModal} billingId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} dataLineID={dataLineID} />}
        {modalEvent.action === "delete" && <DeleteBilling handleCloseModal={closeActionModal} billingId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} dataLineID={dataLineID} />}
      </Modal>

      {loadingDone ? (
          <Table
            columns={columns}
            data={data}
            defaultOrderByKeyFilter={"id"}
            showNumberOfRows={true}
            rowSelection={true}
            multipleRowSelection={false}
            actionRowId={"id"}
            setRowSelection={setSelectedRowsOfTable}
            debugMode={false}
            noDataFoundTitle="No Billings yet"
            isChangeOrderOrVisibilityEnable={false}
            textPosition="center"
            maxHeight="33rem"
            ButtonsAreaLeft={ActionButtons}
            pagerVisibility={false}
            minPageSize={10000}
          />
      ) : (
        <LoadingSpinner />
      )}
     
    </Modal>
  )
}

export default DataLineBillingReport;

interface DataLineBillingReportProps {
  handleCloseModal: () => void;
  dataLineID: number;
}
